<template>
    <div>
        <h1>Branch Limit</h1>
    </div>
</template>
<script>
export default {
    name: 'branch-list'
}
</script>